import { render, staticRenderFns } from "./SmallAction.vue?vue&type=template&id=05c9d644&scoped=true&"
import script from "./SmallAction.vue?vue&type=script&lang=js&"
export * from "./SmallAction.vue?vue&type=script&lang=js&"
import style0 from "./SmallAction.vue?vue&type=style&index=0&id=05c9d644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c9d644",
  null
  
)

export default component.exports